import React from "react";
import { Link } from "react-router-dom";
import styles from "./sobre_mim_dralucianafigueiredo.module.scss";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_dralucianafigueiredo: React.FC = () => {

    return (
        <div className={styles.sobre_mim_dralucianafigueiredo}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/dralucianafigueiredo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img
                        src={require("./src/img_sobremim.png")}
                        alt="Dra. Luciana Figueiredo"
                    />
                </div>
                <h2>Dra. Luciana Figueiredo</h2>
                <p>

                </p>
                <div className={styles.divLogo}>
                    <img
                        className={styles.logoImg}
                        src={require("./src/logo.png")}
                        alt="Logo Dra. Luciana Figueiredo"
                    />
                </div>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    {/* WHATSAPP */}
                    <a
                        href="https://wa.me/5517996735601?text=Olá, gostaria de agendar um horário."
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <WhatsappIcon height="30" color="#ffffff" />
                            </div>
                            <span>Whatsapp</span>
                        </div>
                    </a>

                    {/* LOCALIZAÇÃO */}
                    <a
                        href="https://maps.app.goo.gl/dNeAmvvQR4mmyDXF7"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <MapsIcon height="30" color="#ffffff" />
                            </div>
                            <span>Localização</span>
                        </div>
                    </a>
                    {/* INSTAGRAM */}
                    <a
                        href="https://www.instagram.com/dra.luciana.figueiredo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <InstagramIcon height="26" color="#ffffff" />
                            </div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>

                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a
                        href="https://www.linksvibe.com.br"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_dralucianafigueiredo;
